import { useMediaQuery } from "react-responsive";
import ToggleLightDarkMode from "../Utils/ToggleLightDarkMode";
import styles from "./Header.module.css";
import InfoPopup from "../Utils/InfoPopup";



export default function Header () {

    const isMobile = useMediaQuery({maxWidth: 599});



    if (isMobile) return (
        <div className={styles.center}>
            <div className={styles.mobileToggleContainer}>
                <ToggleLightDarkMode />
            </div>
            <div className={styles.header}>
                <div className={styles.titleCard}>
                        <h1 className={styles.title}>
                            jaN CLARE
                        </h1>
                    <h3 className={styles.info}>Software Engineer</h3>
                </div>
            </div>
        </div>
    );


    return (
        <div className={styles.center}>
            <div className={styles.header}>
                <div className={styles.titleCard}>
                    <h1 className={styles.title}>
                        jaN CLARE
                    </h1>
                    <h3 className={styles.info}>Software Engineer</h3>
                </div>
                <div className={styles.toggleContainer}>
                    <ToggleLightDarkMode />
                </div>
            </div>
        </div>
    );
}